import { collection, deleteDoc, deleteField, doc, onSnapshot, query, setDoc } from 'shared/services/firebase';
import { computed, ref } from 'vue';

export default function useWorkspace(db, user, notionClient, subscriptionManager) {
  const workspaces = ref({});

  const workspacesLoading = ref(false);
  const init = () => {
    workspacesLoading.value = true;
    if (user.value === null) {
      workspacesLoading.value = false;
      return;
    }
    const q = query(collection(db, 'users', user.value.uid, 'workspaces'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      workspaces.value = {};
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        workspaces.value[data.workspace_id] = {
          name: data.workspace_name,
          id: data.workspace_id,
          icon: data.workspace_icon,
          notionToken: data.access_token,
        };
      });
      workspacesLoading.value = false;
    });
    subscriptionManager.addSubscriber(unsubscribe, { auth: true });
  };

  const deleteWorkspace = async (workspace) => {
    await deleteDoc(doc(db, 'users', user.value.uid, 'workspaces', workspace.id));
    if (user.value.lastSelectedWorkspace === workspace.id) {
      await clearLastSelectedWorkspace();
    }
  };

  const clearLastSelectedWorkspace = async () => {
    const userRef = doc(db, 'users', user.value.uid);
    await setDoc(userRef, { lastSelectedWorkspace: deleteField() }, { merge: true });
  };

  const selectedWorkspace = ref({});
  const selectWorkspace = (id) => {
    selectedWorkspace.value = getSingle(id);
    notionClient.initClient(selectedWorkspace.value.notionToken);
  };

  const saveLastSelectedWorkspace = async (workspace) => {
    const userRef = doc(db, 'users', user.value.uid);
    setDoc(userRef, { lastSelectedWorkspace: workspace.id }, { merge: true });
  };

  const getSingle = (id) => workspaces.value[id];

  const getAll = () => computed(() => Object.values(workspaces.value));

  return {
    getAll,
    deleteWorkspace,
    workspacesLoading,
    getSingle,
    init,
    selectWorkspace,
    selectedWorkspace,
    saveLastSelectedWorkspace,
    clearLastSelectedWorkspace,
  };
}
